import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import { isValidElement, Children } from 'react';
import { css } from 'styled-components';
import { getSolidBackgroundShade, getLength, getSpacing } from 'utils/ui';
import { isObjectWithId } from 'types/utils';
/**
 * Get the table's column configuration via JSX from
 * its `children` prop, instead of as a JS object via
 * the `columns` prop
 *
 * @param {Array} children - Table column configuration,
 * must be made of Column components as exported by the
 * Table component
 *
 * @returns {object} Table config as object
 */

var isColumnComponent = function isColumnComponent(child) {
  return /*#__PURE__*/isValidElement(child) && typeof child.type !== 'string' && 'displayName' in child.type && child.type.displayName === 'Column';
};
export function getColumnConfigFromChildren(children) {
  var allChildren = Children.map(children, function (child) {
    if (isColumnComponent(child)) {
      return child.props;
    } else if (child) {
      throw Error('The Table component only accepts children that are instances of the Column component.');
    } else {
      return null;
    }
  }) || [];
  var filteredChildren = allChildren.filter(function (column) {
    return Boolean(column);
  });
  return filteredChildren;
}

/**
 * Uses either the column's name or its cellRenderer
 * to access a cell's data. If no cellRenderer is proviced,
 * the name of the column is used.
 *
 * @param {object} item
 * @param {string|Function} key
 */

export function getCellContent(item, key) {
  if (typeof key === 'string') {
    return item[key] || item[key.toLowerCase()] || null;
  }
  if (typeof key !== 'string') {
    return key(item);
  }
}

/**
 * Returns the name or title of the passed column.
 *
 * @param {object} column
 * @param {string} name
 */

export function getColumnName(column) {
  return column.name || column.title;
}
export var headerBackgroundColor = css(["background-color:", ";"], function (p) {
  return p.shadedHeader ? getSolidBackgroundShade(p.theme) : p.theme.background;
});
export function getBreakpoint(key) {
  return function (p) {
    return p[key] ? p.theme.globals.breakpoints[p[key]] : '0px';
  };
}
export var DEFAULT_LEFT_CELL_PADDING = 's';
export var CHECKBOX_CELL_WIDTH = 20;
export function getCheckboxColumnWidth(p) {
  var width = getLength(CHECKBOX_CELL_WIDTH);
  var padding = getSpacing(p.pl || DEFAULT_LEFT_CELL_PADDING, p.theme);
  return "calc(".concat(width, " + ").concat(padding, ")");
}
export function getDefaultItemKey(item) {
  if (isObjectWithId(item)) {
    return item.id;
  }
  throw Error('Item must be an object with an id property or item key must be defined using getItemKey prop');
}